import React from 'react';
import PropTypes from 'prop-types';

import {styled} from '@mui/system';

import HighlightedItem from '../atoms/HighlightedItem';


const StyledOrganization = styled('span')(({ theme }) =>({
    fontSize: theme.custom.font.medium,
    lineHeight: theme.custom.font.line_height
}));

const StyledOrganizationLocation = styled('span')(({ theme }) =>({
    color: theme.custom.color.grey,
    fontSize: theme.custom.font.medium,
    lineHeight: theme.custom.font.line_height,
    display: "block"
}));

const StyledNoData = styled('span')(({ theme }) =>({
    fontStyle: 'italic',
    fontSize: theme.custom.font.medium
}));


class Organization extends React.Component {
    constructor(props) {
        super(props);
    }

    stopPropagation = (event) => {
        event.stopPropagation();
    };

    contentCallback = () => {
        if(!this.props.organization){
            return (<StyledNoData>n.a.</StyledNoData>);
        }

        let location_parts = [];
        if(this.props.organization.city){
            location_parts.push(this.props.organization.city);
        }
        if(this.props.organization.state){
            location_parts.push(this.props.organization.state);
        }
        if(this.props.organization.country){
            location_parts.push(this.props.organization.country);
        }
        let location_string = '';
        if(location_parts.length){
            location_string = location_parts.join(', ');
        }

        if (!this.props.profileListStyle){
            if(location_string !== ''){
                location_string = ' (' + location_string + ')';
            }
        }

        return (
            <span>
                <StyledOrganization data-bt="organization_name">{this.props.organization.name}</StyledOrganization>{this.props.profileListStyle && <br/>}
                <StyledOrganizationLocation>{location_string}</StyledOrganizationLocation>
            </span>
        );
    };

    render() {
        if (this.props.profileListStyle || this.props.docDetailsStyle){
            return this.contentCallback();
        }
        return (
            <HighlightedItem stats={this.props.stats} contentCallback={this.contentCallback}/>
        );
    }

}

Organization.propTypes = {
    organization: PropTypes.object,
    stats: PropTypes.object,
    profileListStyle: PropTypes.bool,
    docDetailsStyle: PropTypes.bool
};

export default Organization;
